import React from 'react';
import styles from './AuditTrail.module.css';

const MessageAlert = ({ message }) => {
    if (!message.text) return null;

    return (
        <div className={`${styles.message} ${message.type === 'success' ? styles.messageSuccess : styles.messageError}`}>
            {message.text}
        </div>
    );
};

export default MessageAlert;